import React, { useState } from 'react';

interface ProfileTabProps {
  userData: any;
  handleUpdateProfile: (e: React.FormEvent) => Promise<void>;
  handleChangePassword: (e: React.FormEvent) => Promise<void>;
}

const ProfileTab: React.FC<ProfileTabProps> = ({ 
  userData, 
  handleUpdateProfile,
  handleChangePassword
}) => {
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [newName, setNewName] = useState(userData?.name || '');
  const [newEmail, setNewEmail] = useState(userData?.email || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleLocalUpdateProfile = (e: React.FormEvent) => {
    handleUpdateProfile(e);
    setIsEditingProfile(false);
  };

  const handleLocalChangePassword = (e: React.FormEvent) => {
    handleChangePassword(e);
    setIsChangingPassword(false);
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  return (
    <div>
      <h2 className="text-lg font-medium text-gray-900 mb-4">Informații Cont</h2>
      
      {!isEditingProfile && !isChangingPassword ? (
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-medium text-gray-500">Nume</h3>
            <p className="mt-1 text-sm text-gray-900">{userData?.name}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Email</h3>
            <p className="mt-1 text-sm text-gray-900">{userData?.email}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Rol</h3>
            <p className="mt-1 text-sm text-gray-900">{userData?.role === 'admin' ? 'Administrator' : 'Utilizator'}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Membru din</h3>
            <p className="mt-1 text-sm text-gray-900">
              {userData?.createdAt ? new Date(userData.createdAt).toLocaleDateString('ro-RO') : 'Necunoscut'}
            </p>
          </div>
          <div className="pt-4 flex space-x-3">
            <button
              onClick={() => setIsEditingProfile(true)}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Editează Profil
            </button>
            <button
              onClick={() => setIsChangingPassword(true)}
              className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Schimbă Parola
            </button>
          </div>
        </div>
      ) : isEditingProfile ? (
        <form onSubmit={handleLocalUpdateProfile} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Nume</label>
            <div className="mt-1">
              <input
                type="text"
                id="name"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
            <div className="mt-1">
              <input
                type="email"
                id="email"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div className="pt-4 flex space-x-3">
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Salvează
            </button>
            <button
              type="button"
              onClick={() => {
                setIsEditingProfile(false);
                setNewName(userData?.name || '');
                setNewEmail(userData?.email || '');
              }}
              className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Anulează
            </button>
          </div>
        </form>
      ) : (
        <form onSubmit={handleLocalChangePassword} className="space-y-6">
          <div>
            <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700">Parola Curentă</label>
            <div className="mt-1">
              <input
                type="password"
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div>
            <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">Parola Nouă</label>
            <div className="mt-1">
              <input
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Confirmă Parola Nouă</label>
            <div className="mt-1">
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div className="pt-4 flex space-x-3">
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Schimbă Parola
            </button>
            <button
              type="button"
              onClick={() => {
                setIsChangingPassword(false);
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
              }}
              className="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Anulează
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default ProfileTab; 